'use strict';
var getBuiltInStaticMethod = require('../internals/get-built-in-static-method');

module.exports = getBuiltInStaticMethod;
